import * as actionTypes from '../action-types';
import { ResultsType } from './results.types';
import { SearchActions, QueryParamsActions } from '../actions';
import { getSearchErrorData } from '../actions/searchErrorsUtils';

export const defaultState: ResultsType = {
  searchLoading: false,
  hits: [],
  totalHits: -1,
  paginationLoading: false,
  searchTime: -1,
  lastResponse: -1,
  hiddenResults: -1,
  error: undefined,
  query: '',
  theEnd: false,
  resultsWasCut: false,
  adviceAction: null,
  snippets: {
    enterprise: null,
    law: null,
    professional: null,
    commentaries: null,
    legalBasis: null,
  },
  counts: {},
  autoCorrectedQuery: null,
  hasDecisionRef: false,
  recommendedKeywords: [],
  loaded: false,
  restriction: undefined,
};

export function resultsReducer(
  state: ResultsType = defaultState,
  action: QueryParamsActions | SearchActions,
) {
  switch (action.type) {
    case actionTypes.SEARCH_REQUEST: {
      return {
        ...state,
        hits: [],
        snippets: {
          ...state.snippets,
        },
        searchLoading: true,
      };
    }
    case actionTypes.SYNC_URL_PARAMS: {
      return {
        ...state,
        hits: [],
        snippets: { ...defaultState.snippets },
      };
    }

    case actionTypes.UPDATE_TYPE: {
      return {
        ...state,
        theEnd: false,
        hits: [],
        snippets: {
          ...state.snippets,
          commentaries: null,
        },
      };
    }
    case actionTypes.PAGINATION_REQUEST: {
      return {
        ...state,
        paginationLoading: true,
      };
    }
    case actionTypes.SYNC_QUERY_RESPONSE: {
      const { response, queryParams } = action.payload;
      return {
        ...state,
        error: undefined,
        hits: response.hits,
        totalHits: response.totalHits,
        searchTime: response.searchTime,
        lastResponse: response.key,
        theEnd: response.theEnd,
        resultsWasCut: response.wasCut,
        hiddenResults: response.hiddenResults,
        adviceAction: response.adviceAction,
        loaded: true,
        query: queryParams.userQuery,
        autoCorrectedQuery: response.autoCorrectedQuery,
        snippets: {
          enterprise: response.enterprise,
          law: response.law,
          professional: response.professional,
          commentaries: response.commentaries,
          legalBasis: response.legalBasisSnippet,
        },
        recommendedKeywords: response.recommendedKeywords,
        searchLoading: false,
        hasDecisionRef: response.hasDecisionRef,
        counts: {
          ...state.counts,
          [queryParams.type]: response.totalHits,
        },
        restriction: response.restriction,
        exceptExpressions: response?.exceptExpressions,
      };
    }
    case actionTypes.SYNC_PAGINATION_RESPONSE: {
      const { response } = action.payload;
      return {
        ...state,
        hits: [...state.hits, ...response.hits] as ResultsType['hits'],
        lastResponse: response.key,
        resultsWasCut: response.wasCut,
        hiddenResults: response.hiddenResults,
        theEnd: response.theEnd,
        paginationLoading: false,
      };
    }
    case actionTypes.PAGINATION_ERROR: {
      return {
        ...state,
        paginationLoading: false,
      };
    }
    case actionTypes.SYNC_COUNTS: {
      const { counts } = action.payload;
      return {
        ...state,
        counts: {
          ...state.counts,
          ...counts,
        },
      };
    }
    case actionTypes.SEARCH_ERROR: {
      return {
        ...state,
        lastResponse: -1,
        totalHits: 0,
        theEnd: true,
        hits: [],
        counts: {},
        snippets: {},
        loaded: false,
        error: getSearchErrorData(action.payload),
        searchLoading: false,
        paginationLoading: false,
      };
    }
    case actionTypes.SELECT_KEYWORD: {
      return {
        ...state,
        recommendedKeywords: [], // wait for the next keywords from server
      };
    }
    case actionTypes.UNSELECT_KEYWORD: {
      return {
        ...state,
        recommendedKeywords: [], // wait for the next keywords from server
      };
    }
    case actionTypes.CANCEL_PAGINATION_REQUEST: {
      return {
        ...state,
        paginationLoading: false,
      };
    }
    case actionTypes.RESTRICT_TO_ENTERPRISE: {
      return resetResults(state);
    }
    case actionTypes.RESTRICT_TO_LAWYER: {
      return resetResults(state);
    }
    default: {
      return state;
    }
  }
}

function resetResults(state: ResultsType) {
  return {
    ...state,
    theEnd: false,
    hits: [],
  };
}
